import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const RootElement = document.getElementById("root") as HTMLElement;
const Root = ReactDOM.createRoot(RootElement);
Root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
